import { useMemo } from "react";
import { UserRole } from "../../../features/settings/types/settings.types";
import { sidebarConfig } from "./config";
import { SidebarGroupItem, SidebarItem, SidebarItemType } from "./types";

interface UseSidebarItemsProps {
  userRole?: UserRole;
}

export const useSidebarItems = ({ userRole }: UseSidebarItemsProps): SidebarItem[] => {
  return useMemo(() => {
    const filterByRole = (item: SidebarItem): boolean => {
      if (!item.roles || item.roles.length === 0) {
        return true;
      }
      return userRole !== undefined ? item.roles.includes(userRole) : false;
    };

    const filterGroupChildren = (item: SidebarGroupItem): SidebarGroupItem => ({
      ...item,
      children: item.children.filter(filterByRole),
    });

    return sidebarConfig.items
      .filter(filterByRole)
      .map((item) => {
        if (item.type === SidebarItemType.GROUP) {
          return filterGroupChildren(item);
        }
        return item;
      })
      .filter((item) => {
        if (item.type === SidebarItemType.GROUP) {
          return item.children.length > 0;
        }
        return true;
      });
  }, [userRole]);
};
